import { localeService } from '../../../../../core/helpers/locale-service';
export const getLocationName = ({ name, isDefault, }) => {
    const defaultString = localeService.formatMessageById('account.settings.locations.table.row.default');
    return isDefault ? `${name} (${defaultString})` : name;
};
